import { AlertType } from '@stores/alert/types';

export const alertStyleTypes: Record<AlertType, string> = {
  error: 'bg-[rgb(253,237,237)] text-[rgb(95,33,32)]',
  warning: 'bg-[rgb(255,244,229)] text-[rgb(102,60,0)]',
  success: 'bg-[rgb(237,247,237)] text-[rgb(30,70,32)]',
  info: 'bg-[rgb(229,246,253)] text-[rgb(1,67,97)]',
};
